import styled from 'styled-components';
import color from '../../../../constants/color';
import materialUI from '../../../../material-UI';

export const RowInput: any = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;

  @media only screen and (max-width: 1200px) {
   flex-direction: column;
   justify-content: flex-start;
   align-items: start;
  }
`;
export const Info = styled.div`
  font-size: 14px;
  color: ${color.Black};
  margin: 0px 8px 0px 8px;
  font-family: Inter;
  text-align: center;

  @media only screen and (max-width: 1200px) {
    margin: 8px 8px 8px 8px;
  }
`;
export const Img: any = styled.img`
  background-color: #FBC9C9;
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;
export const ContainerIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  cursor: pointer;
  background-color: #FBC9C9;
  border-radius: 30px;
`;
export const OnPress = styled(materialUI.IconButton)`
`;
export const Row = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;
